export default __webpack_public_path__ + "static/media/image-1.915c734f.png";